import { UPLOADS_BASE_URL, UPLOADS_PROJECT_NAME } from '../env';
import { getClientType } from '../session/clientSession';

export { UPLOADS_BASE_URL, UPLOADS_PROJECT_NAME as PROJECT_NAME };

export const getClientFileUrl = (clientType, filePath, project = UPLOADS_PROJECT_NAME) => {
  const cleanPath = String(filePath || '').startsWith('/') ? filePath.slice(1) : filePath;
  return `${UPLOADS_BASE_URL}/api/browse/${project}/${clientType}/${cleanPath}`;
};

export const getClientDataPath = () => getClientFileUrl(getClientType(), '');

export const getClientPath = (relativePath) => {
  const cleanPath = relativePath.startsWith('/') ? relativePath.slice(1) : relativePath;
  return getClientFileUrl(getClientType(), cleanPath);
};

export const clientPaths = {
  networkOffset: () => getClientPath('network_offset.geojson'),
  archiZona: () => getClientPath('archi_zona.geojson'),
  mapGeoJson: () => getClientPath('Map.geojson'),
  metricsCSV: () => getClientPath('metrics.csv'),
  trafficCSV: () => getClientPath('Traffic_5min.csv'),
  metricsJSON: () => getClientPath('metrics.json'),
  ambientaliDaily: (date) => getClientPath(`ambientali/${date}.json`),
  ambientaliIndex: () => getClientPath('ambientali/media_giornaliera.json'),
  environmentHourly: () => getClientPath('Environment_1h.json'),
  noiseDaily: (date) => getClientPath(`geojson/${date}.json`),
  noiseIndex: () => getClientPath('geojson/json_index.json'),
  detectedSounds: () => getClientPath('detected_sounds.json'),
  noiseMinute: () => getClientPath('Noise_1min.json'),
  imuDaily: (filename) => getClientPath(`imu/${filename}`),
  imuIndex: () => getClientPath('imu/index.json'),
  vibrationMinute: () => getClientPath('Vibration_1min.json'),
  animatedVehicles: () => getClientPath('animated_vehicles.geojson'),
  trips: () => getClientPath('trips_deckgl.json'),
  pointCloud3D: () => getClientPath('NuvolaPunti3d.json'),
  buildings: () => getClientPath('buildings.geojson'),
  buildingsLegacy: () => getClientPath('buildings_genova.json'),
  stradeGeo: () => getClientPath('strade/streets_geo.json'),
  stradeTimeseries: () => getClientPath('strade/timeseries_long.json'),
  varchiGeo: () => getClientPath('varchi/varchi_geo.json'),
  varchiTimeseries: () => getClientPath('varchi/varchi_timeseries_long.json'),
  video: (filename) => getClientPath(`videos/${filename}`),
  stradeIcon: () => getClientPath('strade/strade.png'),
  varchiIcon: () => getClientPath('varchi/varchi.png'),
  simfixScenarios: () => getClientPath('grafi_per_scenario.json'),
  simfixArea: () => getClientPath('simfix_area.json'),
  assignxNetwork: () => getClientPath('assignx/assignx_network.geojson'),
  analysisFile: (file) => getClientFileUrl(getClientType(), file, 'analysis'),
  signalFixCarGps: () => getClientPath('signal_fix/Car_gps.geojson'),
  signalFixSegmentiRms: () => getClientPath('signal_fix/segmenti_rms.geojson'),
  signalFixPlyLocations: () => getClientPath('signal_fix/ply_locations.json'),
  signalFixCarPathInfo: () => getClientPath('signal_fix/car_path_info.json'),
  signalFixElements: () => getClientPath('signal_fix/signalfix_elements.json'),
  semafixCatalog: () => getClientPath('semafix/network.json'),
};
